// setupGlobalFetch.ts

import { API_CONFIG } from "@/config/apiConfig";
import {
  getToken,
  isTokenExpired,
  refreshToken,
  removeToken,
} from "@/services/authApi";

let isRefreshing = false;
let queue: ((token: string) => void)[] = [];

export const setupGlobalFetchInterceptor = () => {
  const originalFetch = window.fetch;

  window.fetch = async (input: RequestInfo, init?: RequestInit) => {
    const url = typeof input === "string" ? input : input.url;

    const skipDomains = [
      "https://packtivate-assets.s3.amazonaws.com", 
    ];

    if (skipDomains.some((domain) => url.startsWith(domain))) {
      return originalFetch(input, init);
    }

    // Skip external requests (S3, Firebase, etc.)
    // if (url.startsWith("http://") || url.startsWith("https://")) {
    //   const apiBase = API_CONFIG.baseUrl; // e.g. https://api.packtivate.com

    //   // If it's NOT our backend, don't attach Authorization
    //   if (!url.startsWith(apiBase)) {
    //     return originalFetch(input, init);
    //   }
    // }

    const publicEndpoints = [
      API_CONFIG.domain,
      API_CONFIG.endpoints.auth.login,
      API_CONFIG.endpoints.auth.signup,
      API_CONFIG.endpoints.auth.refresh,
      API_CONFIG.endpoints.auth.forgotpassword,
      API_CONFIG.endpoints.auth.resetpassword,
      "/projects/",
      "/page-responses/",
      "/preview/",
    ];

    if (publicEndpoints.some((endpoint) => url.includes(endpoint))) {
      return originalFetch(input, init); // skip token check
    }

    let token = getToken();

    if (!token) {
      removeToken();
      // 401 redirect is handled by apiHandler
      return new Response(null, { status: 401 });
    }

    if (isTokenExpired(token)) {
      if (!isRefreshing) {
        isRefreshing = true;
        try {
          token = await refreshToken();
          queue.forEach((cb) => cb(token));
          queue = [];
        } catch {
          removeToken();
          window.location.href = "/login";
          return new Response(null, { status: 401 });
        } finally {
          isRefreshing = false;
        }
      } else {
        token = await new Promise<string>((resolve) => queue.push(resolve));
      }
    }

    const headers = new Headers(init?.headers);
    headers.set("Authorization", `Bearer ${token}`);
    // headers.set("Content-Type", "application/json");

    return originalFetch(input, { ...init, headers });
  };
};

// export const setupGlobalFetchInterceptor = () => {
//   const originalFetch = window.fetch;

//   window.fetch = async (input: RequestInfo, init?: RequestInit) => {
//     const url = typeof input === "string" ? input : input.url;

//     // Skip external requests (S3, Firebase, etc.)
//     if (url.startsWith("http://") || url.startsWith("https://")) {
//       const apiBase = API_CONFIG.baseUrl; // e.g. https://api.packtivate.com

//       // If it's NOT our backend, don't attach Authorization
//       if (!url.startsWith(apiBase)) {
//         return originalFetch(input, init);
//       }
//     }

//     const publicEndpoints = [
//       API_CONFIG.endpoints.auth.login,
//       API_CONFIG.endpoints.auth.signup,
//       API_CONFIG.endpoints.auth.refresh,
//       API_CONFIG.endpoints.auth.forgotpassword,
//       API_CONFIG.endpoints.auth.resetpassword,
//       "/projects/",
//       "/page-responses/",
//     ];

//     if (publicEndpoints.some((endpoint) => url.includes(endpoint))) {
//       return originalFetch(input, init);
//     }

//     // eslint-disable-next-line prefer-const
//     let token = getToken();

//     if (!token) {
//       removeToken();
//       return new Response(null, { status: 401 });
//     }

//     if (isTokenExpired(token)) {
//       // ... your existing refresh logic
//     }

//     const headers = new Headers(init?.headers);
//     headers.set("Authorization", `Bearer ${token}`);

//     return originalFetch(input, {
//       ...init,
//       headers,
//     });
//   };
// };
